import store, {StoreState} from "@/store/store";
import {computed, ComputedRef} from "vue";

/**
 * A custom composition function that provides a reactive reference to the Vuex store's state.
 *
 * This function utilizes Vue's `computed` to create a computed reference (`ComputedRef`)
 * that automatically updates whenever the Vuex store's state changes. It allows for
 * easy access and reactivity to the current state of the Vuex store within a Vue component.
 *
 * @return {ComputedRef<StoreState>} A computed reference to the Vuex store's state.
 */
export function useStoreState(): ComputedRef<StoreState> {
  return computed(() => store.state);
}
